export const DEBOUNCE_DELAY_MS = Object.freeze({
  DEFAULT: 166,
  MENU_OPEN_CLOSE_EVENT: 300
});
